var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80735 26.0289C9.44048 27.6505 11.0542 28.0981 12.5964 27.8952C18.5087 27.117 25.1484 23.2836 28.7785 18.5524C29.7254 17.3183 30.1446 15.697 29.0568 14.3379C28.3882 13.5026 27.257 13.1388 26.3151 12.6896C25.0745 12.0892 24.3861 11.0505 23.7244 9.90469C21.1676 5.47622 15.493 3.9658 11.0499 6.53105C6.60673 9.0963 5.07752 14.7658 7.6343 19.1943C8.29579 20.3403 8.85103 21.4558 8.75069 22.8304C8.66882 23.8707 8.41826 25.0323 8.80735 26.0289Z",
    stroke: "#253837",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2667 27.1748C18.8218 28.7363 21.3375 29.101 23.395 27.9131C25.4525 26.7252 26.3945 24.3642 25.8197 22.2367",
    stroke: "#253837",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.66f0705ec201600300d121d68aaac90e.svg";
export { ForwardRef as ReactComponent };